import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router";
import { RentioInternalRenderer } from "../../../components/RentioInternalRenderer";
export var InternalModeButton = function () {
    var navigate = useNavigate();
    return (_jsx("button", { onClick: function () {
            navigate("/rentio-internal");
        }, children: _jsx(RentioInternalRenderer, { children: "INTERNAL MODE" }) }));
};
